import { useBreakpoints } from '@vueuse/core'
import { computed } from 'vue'

const BREAKPOINT_MAP = {
  /* eslint-disable sort-keys-fix/sort-keys-fix,vue/sort-keys -- allow for logical ordering */
  xs: 320,
  sm: 640,
  md: 1024,
  lg: 1920,
  /* eslint-enable sort-keys-fix/sort-keys-fix,vue/sort-keys */
}

export const breakpoints = useBreakpoints(BREAKPOINT_MAP)

export const isDesktop = computed(() => breakpoints.md.value)
